import { twJoin } from 'tailwind-merge'
import { ArrowDownSmoothIcon } from '@systemeio/ui'
import { SortDirectionEnum } from '../enums'

interface TableSortElementProps {
  sortOrder: SortDirectionEnum | undefined
  onSortOrderChange?: () => void
  className?: string
}

export function TableSortElement({
  sortOrder,
  onSortOrderChange,
  className,
}: TableSortElementProps) {
  const sortIcon = (() => {
    switch (sortOrder) {
      case SortDirectionEnum.Asc:
        return <ArrowDownSmoothIcon width={10} height={6} className="mb-1" />
      case SortDirectionEnum.Desc:
        return <ArrowDownSmoothIcon width={10} height={6} className="rotate-180" />
      default:
        return (
          <div className="flex flex-col gap-[1px]">
            <ArrowDownSmoothIcon width={10} height={6} className="fill-text-secondary" />
            <ArrowDownSmoothIcon width={10} height={6} className="fill-text-secondary rotate-180" />
          </div>
        )
    }
  })()

  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation()
        onSortOrderChange?.()
      }}
      className={twJoin('flex items-center', className)}
    >
      <span>{sortIcon}</span>
    </button>
  )
}
